import styled from 'styled-components';

export const Skeleton = styled.div.attrs({
  tabIndex: 0,
  role: 'progressbar',
  'aria-busy': true,
  'aria-valuemin': 0,
  'aria-valuemax': 100,
})`
  display: inline-block;
  background-color: var(--c-nd-50);
  background-size: 312px 100%;
  background-repeat: no-repeat;
  border-radius: var(--half-unit);

  position: relative;
  overflow: hidden;
`;
